/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Mistakesnoresultsdescription3Inputs */

const zh_learn_mistakesnoresultsdescription3 = /** @type {(inputs: Learn_Mistakesnoresultsdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`试试调整搜索关键词或筛选条件`)
};

const en_learn_mistakesnoresultsdescription3 = /** @type {(inputs: Learn_Mistakesnoresultsdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try adjusting your search or filter criteria`)
};

const es_learn_mistakesnoresultsdescription3 = /** @type {(inputs: Learn_Mistakesnoresultsdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intenta ajustar tu búsqueda o criterios de filtro`)
};

/**
* | output |
* | --- |
* | "Try adjusting your search or filter criteria" |
*
* @param {Learn_Mistakesnoresultsdescription3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_mistakesnoresultsdescription3 = /** @type {((inputs?: Learn_Mistakesnoresultsdescription3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Mistakesnoresultsdescription3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_mistakesnoresultsdescription3(inputs)
	if (locale === "en") return en_learn_mistakesnoresultsdescription3(inputs)
	return es_learn_mistakesnoresultsdescription3(inputs)
});
export { learn_mistakesnoresultsdescription3 as "learn_mistakesNoResultsDescription" }